import React, { MouseEventHandler } from 'react'

import Selector from './selector'

interface Range {
    min?: number
    max?: number
    label?: string
}

interface Props {
    type: string
    onClick: any
    min: number | null
    max: number | null
    minKey: string
    maxKey: string
    removable: boolean
    onRemove?: MouseEventHandler
    ranges: Range[]
    unit?: 'ct' | 'MB' | 'ms'
    showCustom: boolean
}

interface State {
    min: number
    max: number
    customized: boolean
}

class RangeSelector extends React.Component<Props> {
    public static defaultProps = {
        removable: false,
        showCustom: false,
    }

    public state: State = {
        min: 100,
        max: 200,
        customized: false,
    }

    public generateRangeString = range => {
        let result

        if (typeof range.min === 'undefined' && typeof range.max === 'undefined') {
            return 'All'
        } else if (typeof range.label !== 'undefined') {
            return range.label
        } else if (typeof range.min !== 'undefined' && typeof range.max === 'undefined') {
            result = '> ' + range.min
        } else if (typeof range.min === 'undefined' && typeof range.max !== 'undefined') {
            result = '< ' + range.max
        } else if (range.min === range.max) {
            result = range.min
        } else {
            result = range.min + '-' + range.max
        }

        if (this.props.unit && this.props.unit !== 'ct') {
            result += ' ' + this.props.unit
        }

        return result
    }

    public onClick = range => {
        return this.props.onClick({ [this.props.minKey]: range.min, [this.props.maxKey]: range.max })
    }

    public OnChange = (min: number, max: number) => {
        return this.props.onClick({ [this.props.minKey]: min, [this.props.maxKey]: max })
    }

    public activateCustomValues = () => {
        this.props.onClick({ [this.props.minKey]: this.state.min, [this.props.maxKey]: this.state.max })
        this.setState({ customized: true })
    }

    public render() {
        // eslint-disable-next-line prefer-const
        let { min, max, ranges } = this.props

        if (ranges.filter(e => e.min === undefined && e.max === undefined).length === 0) {
            ranges.unshift({})
        }

        const selectedRange: Range = {}
        let selectedRanges = ranges
        if (typeof min !== 'undefined' && min !== null && !isNaN(min)) {
            selectedRange.min = min
            selectedRanges = selectedRanges.filter(range => {
                return typeof range.min !== 'undefined' && range.min === min
            })
        } else {
            selectedRanges = selectedRanges.filter(range => {
                return typeof range.min === 'undefined' || range.min === null || isNaN(range.min)
            })
        }
        if (typeof max !== 'undefined' && max !== null && !isNaN(max)) {
            selectedRange.max = max
            selectedRanges = selectedRanges.filter(range => {
                return typeof range.max !== 'undefined' && range.max === max
            })
        } else {
            selectedRanges = selectedRanges.filter(range => {
                return typeof range.max === 'undefined' || range.max === null || isNaN(range.max)
            })
        }

        const headText = this.generateRangeString(selectedRanges.length === 1 ? selectedRanges.shift() : selectedRange)

        return (
            <Selector
                type={this.props.type}
                hasCaret
                removable={this.props.removable}
                onRemove={this.props.onRemove}
                headText={!this.state.customized ? headText : ''}
            >
                <ul className="dropdown-menu" role="menu">
                    {ranges.map(range => (
                        <li key={this.generateRangeString(range)}>
                            <a
                                onClick={() => {
                                    this.onClick(range)
                                    this.setState({ customized: false })
                                }}
                            >
                                {this.generateRangeString(range)}
                            </a>
                        </li>
                    ))}
                    {this.props.showCustom && (
                        <li>
                            <a onClick={this.activateCustomValues}>custom ...</a>
                        </li>
                    )}
                </ul>
                {this.state.customized ? (
                    <form className="form-inline" style={{ float: 'left' }}>
                        <div className="form-group tw-m-0">
                            <div className="input-group">
                                <input
                                    type="number"
                                    className="form-control"
                                    id={'minInput'}
                                    onChange={ev => {
                                        if (!isNaN(parseInt(ev.target.value, 10))) {
                                            this.setState({ min: ev.target.value })
                                            this.OnChange(parseInt(ev.target.value, 10), this.state.max)
                                        }
                                    }}
                                    value={this.state.min}
                                    style={{ maxWidth: '55px' }}
                                />
                                <input
                                    type="number"
                                    className="form-control"
                                    id={'maxInput'}
                                    onChange={ev => {
                                        if (!isNaN(parseInt(ev.target.value, 10))) {
                                            this.setState({ max: ev.target.value })
                                            this.OnChange(this.state.min, parseInt(ev.target.value, 10))
                                        }
                                    }}
                                    value={this.state.max}
                                    style={{ maxWidth: '55px' }}
                                />
                                {this.props.unit ? <div className="input-group-addon"> {this.props.unit} </div> : null}
                            </div>
                        </div>
                    </form>
                ) : null}
            </Selector>
        )
    }
}

export default RangeSelector
